import { Model } from './model';

export abstract class DropdownModel extends Model {
  abstract get dropDownDisplayName(): string;
  abstract get dropDownValue(): Object;
}
